export default __webpack_public_path__ + "static/media/57.e9c6f67f.png";